import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import {
  FormField,
  HelpBlock,
  Label,
  Row,
} from '../../common/form';
import SingleDatePickerWrapper from '../../../../shared/single-date-picker-wrapper';
import FundContext from './context';

const SFormField = styled(FormField)`
  .DateInput_input {
    height: 40px !important;
    padding: 8px 16px !important;
  }

  svg.DateInput_fang, .SingleDatePicker_picker {
    margin-top: -12px;
  }
`;

export default function withNameDatepicker(name, label) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const snake = _.snakeCase(name);

  function PlainDatepicker() {
    const { state, dispatch } = React.useContext(FundContext);

    const onDateChange = d => {
      dispatch({ type: `set${capitalize}`, payload: d });
    };

    const date = state.fund[name];

    return (
      <Row>
        <Label htmlFor={kebab}>{label || name}</Label>
        <SFormField>
          <SingleDatePickerWrapper
            initialDate={date ? moment(date) : null}
            onDateChange={onDateChange}
            isOutsideRange={() => false}
          />
          {state.errors[snake] && <HelpBlock>{state.errors[snake]}</HelpBlock>}
        </SFormField>
      </Row>
    );
  }

  PlainDatepicker.displayName = capitalize;

  return PlainDatepicker;
}
